if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"user_profile","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(21|718|775)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}